import {interval, BehaviorSubject, Subscription} from 'rxjs';
import {map} from 'rxjs/operators';

class TicketTimerService {
  static instance: TicketTimerService | null = null;
  private startTime: Date;
  private timerValueSubject: BehaviorSubject<number>;
  timerValue$;
  private subscriptionCount: number;
  private timeInterval: number;
  private intervalSubscription: Subscription | null;

  constructor(startTime: Date, timeInterval = 1000) {
    this.startTime = startTime;
    this.timeInterval = timeInterval;
    this.timerValueSubject = new BehaviorSubject<number>(0);
    this.timerValue$ = this.timerValueSubject.asObservable();
    this.subscriptionCount = 0;
    this.startTimer();
    this.intervalSubscription = null;
  }

  static getInstance(startTime: Date): TicketTimerService {
    if (!TicketTimerService.instance) {
      TicketTimerService.instance = new TicketTimerService(startTime);
    }
    return TicketTimerService.instance;
  }

  startTimer(): void {
    if (!this.intervalSubscription) {
      this.timerValueSubject.next(
        new Date().getTime() - this.startTime.getTime()
      );
      this.intervalSubscription = interval(this.timeInterval)
        .pipe(map(() => new Date().getTime() - this.startTime.getTime()))
        .subscribe(value => {
          this.timerValueSubject.next(value);
        });
    }
  }

  stopTimer(): void {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
      this.intervalSubscription = null;
    }
  }

  getCurrentTimerValue(): number {
    return this.timerValueSubject.getValue();
  }

  subscribe(): void {
    this.subscriptionCount++;
    if (this.subscriptionCount === 1) {
      this.startTimer();
    }
  }

  unsubscribe(): void {
    this.subscriptionCount--;
    if (this.subscriptionCount === 0) {
      this.stopTimer();
      this.timerValueSubject.complete();
      TicketTimerService.instance = null;
    }
  }
}

export default TicketTimerService;
